<div class="alarm-micro-container">
    <div
        data-cy="dashboard-alarms-tab-left-arrow"
        class="alarm-micro-arrow"
        (click)="onPrevious()"
        [ngClass]="{
            disabled: currentPage === 0
        }"
    >
        <span class="material-symbols-outlined"> arrow_back_ios </span>
    </div>
    <div class="alarm-container">
        <div class="col-alarm-id">
            <p data-cy="dashboard-alarms-tab-alarm-channel">
                {{ alarm.channel }}
            </p>
        </div>
        <div data-cy="dashboard-alarms-tab-alarm-name">
            {{ alarm.name | uppercase }}
        </div>
        <div class="col-status">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <div data-cy="dashboard-alarms-tab-alarm-status">
                {{ alarm.status | uppercase }}
            </div>
        </div>
        <div class="col-alarm-dates">
            <p data-cy="dashboard-alarms-tab-primary-info">
                {{ alarm.value }}<span *ngIf="alarm.value">&#x2022;</span>
                {{ alarm.category }}<span>&#x2022;</span>
                {{ "alarm.table.occurenced" | translate }}
                {{ alarm.occurredAt | date: "yyyy/MM/dd" : "UTC" }} at
                {{ alarm.occurredAt | date: "HH:mm" : "UTC" }} UTC<span
                    >&#x2022;</span
                >
            </p>
            <p data-cy="dashboard-alarms-tab-secondary-info">
                {{ "alarm.table.update" | translate }}
                {{ alarm.updatedAt | date: "yyyy/MM/dd" : "UTC" }} at
                {{ alarm.updatedAt | date: "HH:mm" : "UTC" }} UTC
            </p>
        </div>
        <div class="col-ack-btn">
            <button
                data-cy="dashboard-alarms-tab-ack-button"
                class="primary"
                (click)="ackAlarm(alarm)"
                [disabled]="shouldDisableButton(alarm)"
            >
                {{ "alarm.button.acknowledge" | translate | uppercase }}
            </button>
        </div>
    </div>
    <div
        data-cy="dashboard-alarms-tab-right-arrow"
        class="alarm-micro-arrow"
        (click)="onNext()"
        [ngClass]="{
            disabled: currentPage + 1 >= pages
        }"
    >
        <span class="material-symbols-outlined"> arrow_forward_ios </span>
    </div>
</div>
